module.exports = __webpack_public_path__ + "media/customizations/harvestlife/back-178e2b6bff021796321b8114bb679e69.jpg";